export default "__VITE_ASSET__kD6$3ejL__"